import ApiService from "../../Services/ApiService";
import ApiStocks from "../../Services/ApiStocks";
import moment from "moment";
import _ from "lodash";

export default {
    state: {
        allCompanies: [],
        allCompaniesAndReports: [],
        cachedCompaniesAndReports: [],
        mapCompanies: [],
        companyReports: [],
        stockIds: []
    },
    getters: {
        getAllCompanies(state) {
            return state.allCompanies;
        },
        getMapCompanies(state) {
            return state.mapCompanies;
        },
        getCompanyReports(state) {
            return state.companyReports;
        },
        getAllCompaniesAndReports(state) {
            return state.allCompaniesAndReports;
        },
        getCachedCompaniesAndReports(state) {
            return state.cachedCompaniesAndReports;
        },
        getCompany: (state) => (company_id) => {
            return state.mapCompanies.get(company_id);
        },
        getLatestReport: (state, getters) => (company_id) => {
            const company = state.mapCompanies.get(company_id);
            const companyReports = company.CompanyReports;
            const latestReport = companyReports[companyReports.length - 1];
            const totalnumberofshares = latestReport.totalnumberofshares;
            const price = latestReport.price;//getters.latestPriceToday;
            const ibl = latestReport.ibl;
            const cce = latestReport.cce;
            const ebit = latestReport.ebit;
            const latestDividend = latestReport.ttm_dividend;//getters.sumDividend(company_id);
            const yieldLocal = (latestDividend / price) * 100;
            const ev_ebit = ((totalnumberofshares * price) + (ibl - cce)) / ebit;

            latestReport.ev_ebit = ev_ebit;
            latestReport.yield = yieldLocal;

            return latestReport;
        },
        latestPriceToday(state, getters, rootState, rootGetters) {
            return rootGetters.getLatestPriceToday;
        },
        sumDividend: (state, getters) => (company_id) => {
            const company = state.mapCompanies.get(company_id);
            const companyReports = company.CompanyReports;
            const latestReport = companyReports[companyReports.length - 1];
            const startDate = latestReport.date_report;
            const enddate = moment(startDate).subtract(390, 'days').format('YYYY-MM-DD');

            const reportsBetweenDates = company.CompanyReports.filter((cr) => cr.date_report <= startDate && cr.date_report >= enddate);

            let sumDividend = 0;

            for(const report of reportsBetweenDates) {
                if(report.dividend !== null) {
                    sumDividend += report.dividend;
                }
            }

            return sumDividend;
        },
        getStockIds(state) {
            return state.stockIds;
        }
    },
    mutations: {
        setAllCompanies(state, payload) {
            state.allCompanies = payload;
        },
        setMapCompanies(state, payload) {
            state.mapCompanies = payload;
        },
        setCompanyReports(state, payload) {
            state.companyReports = payload;
        },
        setAllCompaniesAndReports(state, payload) {
            state.allCompaniesAndReports = payload;
        },
        setCachedCompaniesAndReports(state, payload) {
            state.cachedCompaniesAndReports = payload;
        },
        setStockIds(state, payload) {
            state.stockIds = payload;
        }
    },
    actions: {
        async loadCompaniesFourDataPoints({ commit }) {
            let mapCompanies = new Map();
            const responseCompanies = (await ApiService.loadCompaniesFourDataPoints()).data;
            await responseCompanies.forEach((company) => {
                mapCompanies.set(company.company_id, company);
            });
            commit("setAllCompanies", mapCompanies); // Map keyed on the company_id, name, last_report_date, market_cap
        },

        async loadCompanies({ commit, rootState }, payload) {
            let mapCompanies = new Map();
            if (payload) {
                // add the recent tabs
                let company_id_array = payload;
                rootState.Recents.recents.forEach(item => {
                    company_id_array.push(item);
                });
                const companies = (await ApiService.getCompaniesAndReports(company_id_array)).data;
                for (const company of companies) {
                    mapCompanies.set(company.company_id, company);
                }
                commit("setMapCompanies", mapCompanies); // Map keyed on the company_id
            } else {
                console.log('no array of companies --- loading nothing');
            }
        },
        async loadCompanyDataNeeded({ commit, state }, payload) {
            if (!state.mapCompanies.get(payload.company_id)) {
                const company = (await ApiService.getCompaniesAndReportONE(payload)).data;
                let exist_companies = state.mapCompanies;
                exist_companies.set(company.company_id, company);
                commit("setMapCompanies", exist_companies);
            }
        },
        async loadAllCompaniesAndReports({ commit }, company_id_array) {
            const companies = (await ApiService.getAllCompaniesAndReports(company_id_array)).data;

            commit('setAllCompaniesAndReports', companies);
        },
        async loadCompanyReports({ commit }, company_id) {
            const companyReports = _.orderBy((await ApiService.getCompanyReports(company_id)).data, ['period'], ['desc']);

            commit("setCompanyReports", companyReports);
        },
        async loadCompanyReportsOnCompanyIds({ commit }, company_ids) {
            const companyReports = (await ApiService.fetchCompanyReportsOnCompanyIds(company_ids)).data;

            commit('setCompanyReports', companyReports);
        },
        async loadCachedCompaniesAndReports({ commit, rootState }, theme_id) {
            const stockIds = ((await ApiService.getTheme(theme_id)).data).map((s) => s.stock_id);

            commit('setStockIds', stockIds);

            const listOfStocks = (await ApiStocks.loadStocksFromArrayOfStocks({ stocks: stockIds })).data;

            let company_ids = listOfStocks;

            company_ids = _.uniqBy(company_ids, 'company_id');

            company_ids = company_ids.map((s) => s.company_id);

            const companies = (await ApiService.getAllCompaniesAndReports({ company_id_array: company_ids })).data;

            let cachedCompaniesAndReports = rootState.Companies.cachedCompaniesAndReports.concat(companies);

            cachedCompaniesAndReports = _.uniqBy(cachedCompaniesAndReports, 'company_id');

            commit('setCachedCompaniesAndReports', cachedCompaniesAndReports);
        }
    }
};
